import { createContext, useContext } from 'react';

import {
  LabelPaddings,
  SankeyFlow,
  SankeyGraph,
  SankeyNode,
  SankeyNodeMove,
} from '../diagram/types';

export type SankeyRenderState = {
  isReady: boolean;
  graph: SankeyGraph;
  highestNodeAmount: number;
  labelPaddings: LabelPaddings;
  flows: SankeyFlow[];
  nodes: SankeyNode[];
  cycles: FlowCycle[];
  maxDecimalPlaces: number;
  stagesMidpoint: number;
  moveNodeTo: (node: SankeyNode, move: SankeyNodeMove) => void;
  saveNodeMove: (node: SankeyNode) => void;
};

export const emptySankeyRenderContext: SankeyRenderState & {
  hasModified: boolean;
} = {
  isReady: false,
  graph: { w: 0, h: 0, leftMargin: 0 },
  labelPaddings: {
    dy: 0,
    top: 0,
    bot: 0,
    inner: 0,
    outer: 0,
    lblMarginRight: 0,
    lblMarginLeft: 0,
  },
  flows: [],
  nodes: [],
  cycles: [],
  maxDecimalPlaces: 0,
  highestNodeAmount: 0,
  stagesMidpoint: 0,
  moveNodeTo: () => {},
  saveNodeMove: () => {},
  hasModified: false,
};

export const SankeyRenderContext = createContext(emptySankeyRenderContext);

export const useSankeyRenderContext = () => useContext(SankeyRenderContext);
